// WebSocket client for /api/ws/notifications with reconnect + visibility-aware.

const BASE = process.env.REACT_APP_BACKEND_URL || "";
// Convert https:// → wss://, http:// → ws://
const WS_BASE = BASE.replace(/^http/, "ws");

export function connectNotificationsWS({ token, onMessage, onStatus }) {
    let ws = null;
    let reconnectAttempt = 0;
    let stopped = false;
    let reconnectTimer = null;

    const open = () => {
        if (stopped || !token) return;
        const url = `${WS_BASE}/api/ws/notifications?token=${encodeURIComponent(token)}`;
        try {
            ws = new WebSocket(url);
        } catch (e) {
            onStatus?.({ kind: "error", error: String(e) });
            scheduleReconnect();
            return;
        }
        ws.onopen = () => {
            reconnectAttempt = 0;
            onStatus?.({ kind: "open" });
        };
        ws.onmessage = (ev) => {
            try {
                const msg = JSON.parse(ev.data);
                onMessage?.(msg);
            } catch (_e) {
                /* ignore non-JSON */
            }
        };
        ws.onclose = () => {
            onStatus?.({ kind: "close" });
            scheduleReconnect();
        };
        ws.onerror = () => onStatus?.({ kind: "error" });
    };

    const scheduleReconnect = () => {
        if (stopped) return;
        reconnectAttempt++;
        // Cap at 30s
        const delay = Math.min(30_000, 1000 * 2 ** Math.min(reconnectAttempt, 5));
        reconnectTimer = setTimeout(open, delay);
    };

    const close = () => {
        stopped = true;
        if (reconnectTimer) clearTimeout(reconnectTimer);
        try { ws?.close(); } catch (_e) { /* noop */ }
    };

    open();
    return { close };
}
